export default __webpack_public_path__ + "0b6bc19bbdbc97a5961a2884a2ded09c.ttf";